var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3LeftUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002A69",
    fillRule: "nonzero",
    d: "M4.5 6A1.5 1.5 0 0 1 6 4.5h8a1.5 1.5 0 0 1 0 3H9.621l9.097 9.097a1.5 1.5 0 0 1-2.122 2.12L7.5 9.623V14a1.5 1.5 0 0 1-3 0V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3LeftUp);
export default __webpack_public_path__ + "static/media/Arrow_3_left_up.8c610b3efa4e7c0cac53874a9f4ff71d.svg";
export { ForwardRef as ReactComponent };